import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PartyService } from '../Services/party.service';
import { environment } from './../../environments/environment';
import * as moment from 'moment';
import { NgFor } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
    selector: 'app-meeting',
    templateUrl: './meeting.component.html',
    styleUrls: ['./meeting.component.scss'],
    imports: [ReactiveFormsModule, MatInput, MatFormField, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, NgFor, MatOption]
})
export class MeetingComponent implements OnInit {
  @Input() meeting: FormGroup;
  @Input() ID: string;
  @Input() meetingID?: string;
  @Output() stepCompleted = new EventEmitter<string>();
  public meetingRecord: any;
  public meetingRecordDetails: any;
  public meetingTypes: any[] = [];

  constructor(private partyService: PartyService) { }

  ngOnInit(): void {
    this.partyService.getNoteTypes("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/Note Types")
      .subscribe(data => {
        data.Items.$values.forEach(element => {
          this.meetingTypes.push({
            Code: element.Properties.$values[0].Value,
            Description: element.Properties.$values[1].Value
          })
        });
      },
        error => console.log(error)
      );

    if (this.ID !== null && this.ID !== "") {

      this.meeting.get("WorksiteId").setValue(this.ID);
      this.meeting.get("OrganiserId").setValue(this.GetOrganiser());
      this.partyService.getPartySummary(this.ID).subscribe(data => {
        this.meetingRecord = data;
        this.meeting.get("WorkSite").setValue(this.meetingRecord.Name);
        this.partyService.getIQAResult("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/WorkPlaceDetails",this.ID).subscribe(
          result =>
          {
            //if (result.Items.$values[0].Properties.$values.find(x=>x.Name ==="Default").Value.$value === 0 )
              this.meetingRecord.Entity = result.Items.$values[0].Properties.$values.find(x=>x.Name ==="Entity").Value;
          }, err => console.error(err)
        );
      }, error => console.log(error));
    }

    if (this.meetingID !== null && this.meetingID !== "" && this.meetingID !== undefined) {

      this.partyService.getIQAResult("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/MeetingDetails", this.meetingID).subscribe(
        meetingDetails =>
        {
          this.ID = meetingDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="Workplace Id").Value;
          this.meeting.get("WorksiteId").setValue(this.ID);
          this.meeting.get("OrganiserId").setValue(this.GetOrganiser());
    
          this.partyService.getPartySummary(this.ID).subscribe(data => {
            this.partyService.getIQAResult("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/WorkPlaceDetails",this.ID).subscribe(
              workPlaceDetails =>
              {
                //if (result.Items.$values[0].Properties.$values.find(x=>x.Name ==="Default").Value.$value === 0 )
                this.meetingRecord.Entity = workPlaceDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="Entity").Value;
                this.meetingRecord = {...this.meetingRecord, ...data};
                this.meeting.get("WorkSite").setValue(this.meetingRecord.Name);
              //if (result.Items.$values[0].Properties.$values.find(x=>x.Name ==="Default").Value.$value === 0 )
                this.meetingRecord.MeetingDate = meetingDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="TransactionDate").Value;
                this.meetingRecord.MeetingType = meetingDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="Type").Value;
                this.meetingRecord.MeetingTitle = meetingDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="Description").Value;
                this.meetingRecord.Note = meetingDetails.Items.$values[0].Properties.$values.find(x=>x.Name ==="Note").Value ?? null;
                this.PopulateForm();
              }, err => console.error(err)
            );
            


        }, err => console.error(err));
      }, error => console.log(error));

    }
  }

  PopulateForm(): void {
    if (!!this.meetingRecord.MeetingType){
      this.meeting.get("MeetingType").setValue(this.GetMeetingType());
    }
    if (!!this.meetingRecord.MeetingDate){
      this.meeting.get("MeetingDate").setValue(this.GetMeetingDate());
    }
    if (!!this.meetingRecord.MeetingTitle){
      this.meeting.get("MeetingTitle").setValue(this.meetingRecord.MeetingTitle);
    }
    if (!!this.meetingRecord.Note){
      this.meeting.get("Note").setValue(this.meetingRecord.Note);
    }

    if (!!this.meeting.get("MeetingType").value !== null){
      this.SelectMeetingType(true);
    }
  }

  GetMeetingType(): string|null {
    // Check if meetingRecord is defined and contains the Type property
    if (this.meetingRecord && this.meetingRecord.MeetingType) {
      return this.meetingRecord.MeetingType;
    }
    return null; // Return null if the value is not available
  }
  
  GetMeetingDate(): string|null {
    // Check if meetingRecord is defined and contains the MeetingDate property
    if (this.meetingRecord && this.meetingRecord.MeetingDate) {
      // Return the MeetingDate string for the date picker
      const formattedMeetingDate = moment(this.meetingRecord.MeetingDate).format('YYYY-MM-DDT00:00:00');
      this.meetingRecord.MeetingDate = formattedMeetingDate;
      return formattedMeetingDate;
    }
    return null; // Return null if the value is not available
  }

  GetOrganiser(): any {
    if (!environment.production){
      return "41";
    }
    else
      { 
        let organiser =  (<HTMLInputElement>document.getElementById("__ClientContext")) === undefined ? "" : JSON.parse((<HTMLInputElement>document.getElementById("__ClientContext")).value);
        return organiser.loggedInPartyId !== organiser.selectedPartyId ? organiser.selectedPartyId : organiser.loggedInPartyId ?? "";
      }
  }

  // GetOrganiser(): any {
  //   console.log((<HTMLInputElement>document.getElementById("__ClientContext")).value);
  //   let details = JSON.parse((<HTMLInputElement>document.getElementById("__ClientContext")).value);
  //   return details.loggedInPartyId !== details.selectedPartyId ? details.selectedPartyId : details.loggedInPartyId;
  // }

  get ShowWorkSiteLabel() {
    return this.meeting.get("WorkSite").value === null;
  }
  
  UpdateNote(event): void {
    // handle when Note has been changed after pre-filling
    if (this.meetingRecord.Note !== event.target.value){
      this.meetingRecord.Note = event.target.value;
    }
  }

  UpdateTitle(event): void {
    // handle when Title has been changed after pre-filling
    if (this.meetingRecord.MeetingTitle !== event.target.value){
      this.meetingRecord.MeetingTitle = event.target.value;
    }

  }

  SelectMeetingDate(event): void {
    console.log(`meeting date: ${event}`);
    // handle when Date has been changed after pre-filling
    if (this.meetingRecord.MeetingDate !== event){
      const formattedMeetingDate = moment(event, 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00');
      this.meetingRecord.MeetingDate = formattedMeetingDate;
      // this.meetingRecord.MeetingDate = event;
    }
  }

  SelectMeetingType(meeting) {
    // handle when Type has been changed after pre-selecting
    if (meeting !== true && this.meetingRecord.MeetingType !== meeting.value){
      this.meetingRecord.MeetingType = meeting.value;
    }
    
    this.stepCompleted.emit(this.meetingRecord);
  }

}
